import config from '@/app/editor/config';
const api = (function ($) {
  const $body = $('html>body');
  const domain = $body.attr('data-domain');
  let origin = '';
  if (domain && domain.length) origin = domain + '/';

  return {
    generateShareableLink(shop, kind, id) {
      const url = `/api/templates/${kind}/${id}/public`;
      return {
        type: config.isDev() ? 'get' : 'post',
        url: url,
      };
    },
    updateShareableLink(shop, kind, templateId, linkId) {
      const url = `/api/templates/${kind}/${templateId}/public/${linkId}`;
      return {
        type: config.isDev() ? 'get' : 'put',
        url: url,
      };
    },
    getSnippet(shop, id, hasUpdate) {
      let url, body;
      if (config.isDev()) {
        url = '/api/snippet/getSnippet.html';
      } else {
        if (hasUpdate) {
          url = '/api/snippets/update/' + id;
        } else {
          url = '/api/snippets/' + id;
        }
      }

      return {
        type: config.isDev() ? 'get' : hasUpdate ? 'put' : 'post',
        url: url,
      };
    },
    removeSnippet(shop, id) {
      let type, url;
      url = `${origin}/api/snippets/${id}`;
      type = 'DELETE';
      return {
        type: type,
        url: url,
      };
    },
    updateAllSnippet(shop) {
      return {
        type: config.isDev() ? 'GET' : 'PUT', //"PUT",
        url: config.isDev() ? '/api/snippet/updateAllSnippets.html' : '/api/snippets/update_all',
      };
    },
    getCategories(shop) {
      let url;
      url = '/api/categories/all';
      return {
        type: 'GET',
        url,
      };
    },
    // cids: category ids. Eg: 1,2,3,4,5,6
    getMySnippets(shop, cids) {
      const url = '/api/snippets/my?cids=' + cids;
      return {
        type: 'GET',
        url,
      };
    },
    saveSnippetUsage(shop) {
      return {
        type: config.isDev() ? 'get' : 'post',
        url: config.isDev() ? '/api/snippet/snippetUsage.html' : '/api/snippets/usage',
      };
    },
    markSnippet(id) {
      return {
        type: 'POST',
        url: '/api/element/markAsUsed.html',
      };
    },
    getArticles() {
      return {
        type: 'GET',
        url: '/api/article/getArticles.html',
      };
    },
    getLatestProduct() {
      return {
        type: "GET",
        url: "/api/product/getProduct"
      };
    },
    searchArticles() {
      return {
        type: 'GET',
        url: '/api/article/searchArticles.html',
      };
    },
    getBlogs() {
      return {
        type: 'GET',
        url: '/api/blog/getBlogs.html',
      };
    },
    searchBlogs() {
      return {
        type: 'GET',
        url: '/api/blog/searchBlogs.html',
      };
    },
    getCollections() {
      return {
        type: 'GET',
        url: '/api/collection/getCollections.html',
      };
    },
    getCollectionsByIds() {
      return {
        type: 'GET',
        url: '/api/collection/getCollectionsByIds.html',
      };
    },
    searchCollections() {
      return {
        type: 'GET',
        url: '/api/collection/searchCollections.html',
      };
    },
    getProduct() {
      return {
        type: 'GET',
        url: '/api/product/getProduct.html',
      };
    },
    getProducts() {
      return {
        type: 'GET',
        url: '/api/product/getProducts.html',
      };
    },
    getRelatedProducts() {
      return {
        type: 'GET',
        url: '/api/product/getRelatedProducts.html',
      };
    },
    searchProducts() {
      return {
        type: 'GET',
        url: '/api/product/searchProducts.html',
      };
    },
    getPages() {
      return {
        type: 'GET',
        url: '/api/page/getPages.html',
      };
    },
    uploadImage() {
      return {
        type: 'POST',
        url: '/api/image/upload',
      };
    },
    countBlocks() {
      return {
        type: 'POST',
        url: '/api/blocks',
      };
    },
    getMaps() {
      return {
        type: 'GET',
        url: '/api/upgrade/getMaps.html',
      };
    },
    saveOption() {
      return {
        type: 'GET',
        url: '/api/option/saveOption.html',
      };
    },
    checkPageHandle() {
      return {
        type: 'POST',
        url: '/api/page/checkPageHandle.html',
      };
    },
    savePage() {
      return {
        type: 'POST',
        url: '/api/page/savePage.html',
      };
    },
    getProductsByIds() {
      return {
        type: 'GET',
        url: '/api/product/getProductsByIds.html',
      };
    },
    getProductsByCollectionIds() {
      return {
        type: 'GET',
        url: '/api/product/getProductsByCollectionIds.html',
      };
    },

    dummy() {
      return {
        type: 'POST',
        url: `${origin}`,
      };
    },

    updateProductSchema() {
      return {
        type: 'PUT',
        url: '/api/pages/toggle-product-schema',
      };
    },

    getlistIcons() {
      return {
        type: 'GET',
        url: '/api/icons',
      };
    },
  };
})(jQuery);

export default api;
